import styled from 'styled-components';

import { mobileGridCSS, webGridCss } from './styles';
import { IContentProps } from './types';

const Content = styled.div<IContentProps>`
  margin: 0 auto;
  width: 100%;
  max-width: ${Styles.layout.sectionMaxWidth};
  display: grid;

  padding: 1rem;
  grid-gap: 1.5rem;
  ${(p: IContentProps) => mobileGridCSS(p)}
  grid-template-columns: 100%;

  ${Styles.desktopLarge`
    padding: 2rem 3rem;
    grid-gap: 2rem;
    ${(p: IContentProps) => webGridCss(p)}
    grid-template-columns: 60% auto;
    grid-template-rows: min-content min-content 1fr;
  `}
`;

export default Content;
